module.exports = __webpack_public_path__ + "static/img/Explorer_ar@2x.1995d4ad.png";